import createCachedSelector from "re-reselect";
import { createSelector } from "reselect";
import { denormalize } from "normalizr";
import schemas from "utils/schemas";

const DEFAULT_WARRANTY_FLAGS = { loading: true, loaded: false };

const getFlags = (documentWarrantyState, _, key) => documentWarrantyState[key] || DEFAULT_WARRANTY_FLAGS;
const getWarrantyDataState = (_, entitiesWarrantyState, key) => entitiesWarrantyState[key];
const getWarrantySummaryDataState = (_, entitiesWarrantySummaryState, key) => entitiesWarrantySummaryState[key];

export const getWarrantyFlags = createCachedSelector(
  getFlags,
  flags => flags
)((_documentWarrantyState, _entitiesWarrantyState, key) => key);

export const getWarranties = createCachedSelector(getWarrantyFlags, getWarrantyDataState, (flags, warranties) => {
  if (!flags.loaded) {
    return [];
  }
  return warranties;
})((_documentWarrantyState, _entitiesWarrantyState, key) => key);

export const getWarrantySummaryFlags = createCachedSelector(
  getFlags,
  flags => flags
)((_documentWarrantySummaryState, _entitiesWarrantySummaryState, key) => key);

export const getWarrantiesSummary = createCachedSelector(
  getWarrantySummaryFlags,
  getWarrantySummaryDataState,
  (flags, warrantiesSummary) => {
    if (!flags.loaded) {
      return [];
    }
    return warrantiesSummary;
  }
)((_documentWarrantyState, _entitiesWarrantyState, key) => key);

const getAssetsIsLoaded = currentOfferAssetsState => currentOfferAssetsState.isLoaded;
const getAssetsState = currentOfferAssetsState =>
  currentOfferAssetsState.map(asset => {
    return {
      documentDetailId: asset.documentDetailId,
      documentDetailSiteId: asset.siteId,
      documentDetailName: asset.assetDescription
    };
  });

export const getDocumentAssets = createSelector([getAssetsIsLoaded, getAssetsState], (isLoaded, assetsHeader) => {
  if (!isLoaded) return [];

  return assetsHeader;
});

export const getDefaultWarrantyData = (state, documentId) => {
  var result = {};
  const asset = state.currentOffer.assetData.assetsHeader[0];

  const isInFolder = state.currentOffer.header.isInvalid;
  const currencySource = isInFolder
    ? state.currentFolder.financedOffers && state.currentFolder.financedOffers.isLoaded
      ? denormalize([documentId], [schemas.financedOffer], state.entities)
      : null
    : asset?.currencyId
    ? asset
    : state.currentOffer.header;

  if (currencySource) {
    result.currencyId = isInFolder ? currencySource[0]?.currencyId : currencySource.currencyId;
    result.currencyCode = isInFolder ? currencySource[0]?.currency : currencySource.currencyCode;
  }
  if (asset) {
    result.documentDetail = {
      documentDetailId: asset.documentDetailId,
      documentDetailSiteId: asset.siteId,
      documentDetailName: asset.assetDescription
    };
    if (asset.partner && asset.partner.dealer)
      result.issuer = { issuerId: asset.partner.dealer.dealerId, issuerName: asset.partner.dealer.name };
  }
  return result;
};
